import { SnackbarStatus } from 'src/components/snackbar/SnackbarLauncher';
import { LineOfCreditAsyncTasks } from 'src/types/LineOfCredit';

export interface LocModalStatus {
  showModal: boolean;
  locId: string | null;
}

export const getLineOfCreditAsyncTasksMessagesMap = (
  entityNameSingular: string
): Record<string, string> => ({
  [`${LineOfCreditAsyncTasks.CREATE_BUDGET_BASIC_ACCOUNT}-${SnackbarStatus.IN_PROGRESS}`]: `Your ${entityNameSingular} is in the works`,
  [`${LineOfCreditAsyncTasks.CREATE_BUDGET_BASIC_ACCOUNT}-${SnackbarStatus.SUCCESS}`]: `Your ${entityNameSingular} is ready`,
  [`${LineOfCreditAsyncTasks.CREATE_BUDGET_BASIC_ACCOUNT}-${SnackbarStatus.ERROR}`]: `There was a problem creating your ${entityNameSingular}. Try again.`,
  [`${LineOfCreditAsyncTasks.UPDATE_BUDGET_BASIC_ACCOUNT}-${SnackbarStatus.IN_PROGRESS}`]: `Updating your ${entityNameSingular}`,
  [`${LineOfCreditAsyncTasks.UPDATE_BUDGET_BASIC_ACCOUNT}-${SnackbarStatus.SUCCESS}`]: `Your ${entityNameSingular} has been updated`,
  [`${LineOfCreditAsyncTasks.UPDATE_BUDGET_BASIC_ACCOUNT}-${SnackbarStatus.ERROR}`]: `There was a problem updating your ${entityNameSingular}. Try again.`,
  [`${LineOfCreditAsyncTasks.DEACTIVATE_BUDGET_BASIC_ACCOUNT}-${SnackbarStatus.IN_PROGRESS}`]: `Deleting your ${entityNameSingular}`,
  [`${LineOfCreditAsyncTasks.DEACTIVATE_BUDGET_BASIC_ACCOUNT}-${SnackbarStatus.SUCCESS}`]: `Your ${entityNameSingular} has been deleted`,
  [`${LineOfCreditAsyncTasks.DEACTIVATE_BUDGET_BASIC_ACCOUNT}-${SnackbarStatus.ERROR}`]: `There was a problem deleting your ${entityNameSingular}. Try again.`,
});

export const LineOfCreditAnalyticsEventLabelMap: Record<string, string> = {
  [LineOfCreditAsyncTasks.CREATE_BUDGET_BASIC_ACCOUNT]: 'create new loc_cta',
  [LineOfCreditAsyncTasks.UPDATE_BUDGET_BASIC_ACCOUNT]: 'edit loc_cta',
  [LineOfCreditAsyncTasks.DEACTIVATE_BUDGET_BASIC_ACCOUNT]: 'delete loc_cta',
};
